import createClient, { Client } from 'openapi-fetch';
import { paths } from '@upstart/backend-client';
import BackendService, { BACKEND_URL } from 'services/BackendService';

export const useTypedBackendClient = (): { backendClient: Client<paths> } => {
  const fetchWrapper: typeof fetch = (input, options) =>
    BackendService.callFetch(input, options);
  const backendClient = createClient<paths>({
    baseUrl: BACKEND_URL,
    fetch: fetchWrapper,
  });

  return { backendClient };
};
